
import { defineComponent } from "@vue/runtime-core"
import GridSkeleton from "./grid.vue"
export default defineComponent({
  props: {
    loadingmsg: { type: String, required: false, default: "" }
  },
  components: { GridSkeleton }
})
